import { Icon } from "simplydo/react/ui";

import type { CompanyResearch } from "components/innointel/types";

import {
  InfoBoxWidget,
  InfoBoxWidgetTitleArea,
  InfoContainer,
  InfoItem,
  KeyFactLink,
} from "../Styles";

export const getUkriLink = (projectUrl?: string) => {
  const splitter = "/gtr.portal/";
  if (!projectUrl) return projectUrl;
  if (projectUrl.indexOf(splitter) === -1) return projectUrl;
  const splitProjectUrl = projectUrl.split(splitter);
  if (splitProjectUrl.length === 2) {
    return `https://gtr.ukri.org/${splitProjectUrl[1]}`;
  }
  return projectUrl;
};

type CompanyFundedResearchProps = { fundingData: CompanyResearch[] };

const CompanyFundedResearch = ({ fundingData }: CompanyFundedResearchProps) => {
  if (fundingData.length) {
    return (
      <InfoBoxWidget $sectioned>
        <InfoBoxWidgetTitleArea>
          <Icon name="folder" />
          <div>
            <h3>Funded research</h3>
            <span>{fundingData.length} project(s) found</span>
          </div>
        </InfoBoxWidgetTitleArea>
        <InfoContainer $wrapped>
          {fundingData.slice(0, 10).map((project, index) => (
            <InfoItem
              key={`${project.title ?? "project"}-${index}`}
              href={getUkriLink(project.url)}
            >
              <KeyFactLink
                title={`${project.title ?? "Untitled"} - ${project.grantCategory ?? ""}`}
                fact={
                  project.fund
                    ? `£${project.fund.valuePounds ?? 0}, ${project.fund.start ?? ""} - ${project.fund.end ?? ""}`
                    : ""
                }
              />
            </InfoItem>
          ))}
        </InfoContainer>
      </InfoBoxWidget>
    );
  }
  return null;
};

export default CompanyFundedResearch;
